export default "__VITE_ASSET__08db7283__"